/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

// Import zone flags first to ensure CommonJS polyfills are loaded before anything else
import './zone-flags';

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// Enhanced CommonJS polyfills
if (typeof window !== 'undefined') {
  // Ensure global is available
  (window as any).global = window;

  // Global module/exports make jasmine.js take its CommonJS branch and skip
  // creating window.jasmineRequire, which breaks Karma's boot.js — keep these
  // shims (needed by @mintplayer/video-player) out of test pages
  const underKarma = !!(window as any).__karma__;

  // Create a proper exports object that can be modified
  if (!underKarma && !(window as any).exports) {
    (window as any).exports = {};
  }

  // Create a proper module object
  if (!underKarma && !(window as any).module) {
    (window as any).module = { exports: {} };
  }

  // Enhanced require function that can handle basic module resolution
  if (!(window as any).require) {
    (window as any).require = function (id: string) {
      console.warn(`require('${id}') called but not implemented`);
      return {};
    };
  }

  // Ensure process is available
  if (!(window as any).global.process) {
    (window as any).global.process = {
      env: {},
      nextTick: function (fn: Function) {
        setTimeout(fn, 0);
      }
    };
  }

  // Specific polyfill for @mintplayer/video-player
  // This library seems to expect exports to be available in the global scope
  if (!underKarma) {
    Object.defineProperty(window, 'exports', {
      value: {},
      writable: true,
      configurable: true
    });

    // Also ensure module.exports is available
    Object.defineProperty(window, 'module', {
      value: { exports: {} },
      writable: true,
      configurable: true
    });
  }
}

// Polyfill for process
import * as process from "process";
(window as any).global.process = process;

// Polyfill for util
try {
  const util = require("util");
  (window as any).global.util = (window as any).global.util || util;
} catch (e) {
  (window as any).global.util = (window as any).global.util || {};
}

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import "zone.js"; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
